<template>
  <div class="whatsapp-button-container">
    <a
      :href="whatsappLink"
      target="_blank"
      class="fixed bottom-4 right-4 md:bottom-6 md:right-6 lg:bottom-8 lg:right-10 
             z-50 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 
             rounded-full bg-green-500 flex items-center justify-center shadow-lg 
             hover:bg-green-600 transition duration-300"
      title="Entre em contato via WhatsApp"
    >
      <span class="pulse-ring"></span>
      <span class="pulse-ring"></span>
      <span class="pulse-ring"></span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        class="fill-white relative z-10"
        :width="iconSize"
        :height="iconSize"
      >
        <path
          d="M16.01 3C9.38 3 4 8.38 4 15c0 2.24.59 4.39 1.71 6.3L3 29l7.8-2.71c1.87 1 4 1.5 6.21 1.5 6.62 0 12-5.38 12-12S22.63 3 16.01 3Zm0 2c5.53 0 10 4.47 10 10s-4.47 10-10 10c-1.94 0-3.79-.57-5.4-1.6l-.4-.24-4.6 1.61 1.63-4.6-.26-.42C6.57 18.83 6 16.95 6 15c0-5.53 4.47-10 10-10Zm-3.25 3c-.12 0-.26.02-.4.04-.27.04-.58.19-.87.65-.3.46-1.15 1.14-1.15 2.77s1.18 3.22 1.34 3.44c.16.23 2.33 3.72 5.71 4.94.8.31 1.43.5 1.93.64.81.2 1.55.17 2.14.1.65-.07 2-.81 2.28-1.59.28-.78.28-1.45.2-1.59-.08-.14-.3-.23-.64-.4-.35-.18-2.07-1.03-2.39-1.15-.31-.12-.54-.17-.77.16-.23.33-.88 1.15-1.08 1.39-.2.24-.39.25-.72.1-.34-.16-1.41-.51-2.68-1.63-1-1.03-1.67-2.29-1.87-2.67-.2-.38-.02-.59.14-.74.15-.15.34-.4.51-.6.17-.2.23-.34.34-.57.11-.22.06-.43-.03-.6-.08-.17-.74-1.85-1.02-2.43-.23-.49-.46-.51-.66-.52Z"
        />
      </svg>
    </a>
  </div>
</template>

<script setup>
const phoneNumber = "5561999757400"; 
const message = "Olá, vim através do site!";
const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

// Ajusta o tamanho do ícone para ser responsivo
const iconSize = "28";   // Padrão
</script>

<style scoped>
.whatsapp-button-container {
  position: relative;
}

.pulse-ring {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 4px solid #25d366;
  border-radius: 50%;
  animation: pulse-ring 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

.pulse-ring:nth-child(1) {
  animation-delay: 0s;
}

.pulse-ring:nth-child(2) {
  animation-delay: 0.6s;
}

.pulse-ring:nth-child(3) {
  animation-delay: 1.2s;
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
